/**
 * @file The Part cell of one fetch part: what the operator entered and what it resolved to.
 * Consumer: `SignifyFetchJobPartTable`. It subscribes to its own part document alone.
 * A picked part carries its product from the moment the job is created, so it shows the name and
 * codes immediately; a pasted token shows the token verbatim until resolution finds a product,
 * which is what "Resolves when fetched" says. The second line uses the same
 * `commercialCode | 12NC: code` shape as the product search, so one part reads the same everywhere.
 */

import { FC } from 'react';
import { Typography } from 'antd';
import { useSnapshot } from 'valtio';
import FlexCol from '@/components/atoms/FlexCol';
import type { SignifyFetchPart } from '#types';

const { Text } = Typography;

const SignifyFetchJobPartCell: FC<{ part: SignifyFetchPart }> = ({ part }) => {
  const snap = useSnapshot(part);

  return (
    <FlexCol gap={0}>
      <Text>{snap.product ? snap.product.name : snap.input}</Text>
      <Text type="secondary">
        {snap.product
          ? `${snap.product.commercialCode} | 12NC: ${snap.product.code}`
          : 'Resolves when fetched'}
      </Text>
    </FlexCol>
  );
};

export default SignifyFetchJobPartCell;
